import { SignInUrlBuilder } from '@tableau/shared-urls';
import * as React from 'react';

import { RootLoginUi } from '~src/authentication/components/Login/RootLoginUi';

import { ProcessAndRemoveSamlQueryWrapper } from '../../../app/spaces/RouterHelpers/ProcessAndRemoveSamlQueryWrapper';
import { MobileAppBanner } from '../../../mobile/components/MobileAppBanner';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export interface SignInProviderProps {
  readonly routeLocationSearch: string;
}

export class SignInProvider extends React.Component<SignInProviderProps> {
  public render() {
    return (
      <DefaultServerTitleWrapper>
        <ProcessAndRemoveSamlQueryWrapper>
          <div>
            <MobileAppBanner />
          </div>
          <div>
            <RootLoginUi {...this.props}
              signinQueryParams={SignInUrlBuilder.queryParamsFromQuery(this.props.routeLocationSearch)}
            />
          </div>
        </ProcessAndRemoveSamlQueryWrapper>
      </DefaultServerTitleWrapper>
    );
  }
}
